<div class="page-header min-h row {{ publicClass }} align-items-center"
  [ngClass]="{ close_icon: navService.collapseSidebar }"
  [ngStyle]="{ display: hideScroolNavService.headerFixed ? 'none' : 'flex' }">
  @if(publicClass){
  <img class="img-fluid logo pointer" [routerLink]="['/home']" src="assets/images/logo/logo.png" alt="" />
  <img class="img-fluid logo-min pointer bg-white" [routerLink]="['/home']" src="assets/images/logo/logo-icon.png"
    alt="" />
  }
  <div class="header-logo-wrapper col-auto">
    <div class="logo-wrapper">
      <a [routerLink]="['/home']">
        <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="" />
        <img class="img-fluid for-dark bg-white" src="assets/images/logo/logo.png" alt="" /></a>
    </div>
  </div>
  <!-- <div class="col-4 col-xl-4 page-title" *ngIf="userSession">
    <app-breadcrumb></app-breadcrumb>
  </div> -->
  <div class="header-wrapper col m-0">
    <div class="row">
      <app-search-small-header [isSearchOpen]="isSearchOpen"></app-search-small-header>
      <div class="header-logo-wrapper col-auto p-0">
        <div class="logo-wrapper">
          <a [routerLink]="['/home']">
            <img class="img-fluid" src="assets/images/logo/logo.png" alt="" /></a>
        </div>
        @if(!publicClass){
        <div class="toggle-sidebar" (click)="sidebarToggle()">
          <app-common-svg-icon [class]="'stroke-icon sidebar-toggle status_toggle middle'"
            [icon]="'toggle-icon'"></app-common-svg-icon>
        </div>
        }
      </div>
      <div class="nav-right col-xxl-8 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto">
        <ul class="nav-menus">
          <li class="position-relative">
            <span class="header-search" (click)="isSearchOpen = !isSearchOpen">
              <app-common-svg-icon [icon]="'search'"></app-common-svg-icon>
            </span>
          </li>
          <li>
            <app-search></app-search>
          </li>
          <!-- <li (click)="navService.language = !navService.language">
            <app-language></app-language>
          </li> -->
          <!-- <li class="onhover-dropdown">
            <app-notitications></app-notitications>
          </li>
          <li class="onhover-dropdown" (click)="isFlip = !isFlip">
            <app-bookmark [item]="isFlip"></app-bookmark>
          </li> -->
          <li>
            <app-theme-mode></app-theme-mode>
          </li>
          <!-- <li class="onhover-dropdown">
            <app-messages></app-messages>
          </li> -->
          <li class="cart-nav onhover-dropdown">
            <app-cart></app-cart>
          </li>
          @if (isPortalLoggedIn) {
          <li class="profile-nav onhover-dropdown px-0 py-0">
            <app-profile [userSession]="userSession"></app-profile>
          </li>
          }@else{
          <li class="bg-tr">
            <button class="btn btn-primary buy-btn pointer m-2" type="submit" (click)="clickSignIn()">
              <span class="pointer">Sign in</span>
            </button>
          </li>
          <li>
            <button class="btn btn-primary buy-btn pointer m-2" type="submit" (click)="clickSignUp()">
              <span class="pointer">Sign up</span>
            </button>
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>